import api from './../services/api.js'

const YEAR_CODES = {
  '2019': 1,
  '2020': 2
}

export default {
  namespaced: true,
  state: {
    companies: null,
    companiesLoaded: false,
    currentCompany: null,
    programs: null
  },
  getters: {
    getCompanies: (state) => {
      return state.companies
    }
  },
  mutations: {
    setCompany: (state, data) => {
      state.currentCompany = data
    },
    setCompanies: (state, data) => {
      state.companies = data
    },
    setCompaniesLoaded: (state, data) => {
      state.companiesLoaded = data
    },
    setPrograms: (state, programs) => {
      state.programs = programs
    }
  },
  actions: {
    getCompaniesData: ({commit}, year) => {
      return api.getCompanies().then((resp) => {
        const data = resp.data.filter(item => item.fields.years.includes(YEAR_CODES[year])).map((item) => {
            item.fields.coordinates = [parseFloat(item.fields.latitude), parseFloat(item.fields.longitude)]
          return item.fields
        })

        commit('setCompaniesLoaded', true)
        commit('setCompanies', data)
        return data
      })
    },
    getCompanyById: ({commit}, id) => {
      api.getCompany(id).then((resp) => {
        commit('setCompany', resp.data)
        return resp.data
      })
    },
    getPrograms: ({commit}, year) => {
      api.getPrograms().then((resp) => {
        const data = resp.data.find(item => item.year === parseInt(year, 10))
        commit('setPrograms', data.programs)
        return data
      })
    }
  }
}
